import {
    inject,
    Injectable
} from '@angular/core';

import {
    ActiveSaleService
} from 'src/app/features';

import {
    ConfigurationManagerService
} from 'src/app/core';

import {
    AlertDialogService
} from '../alert-dialog';

import {
    PromptDialogService
} from '../prompt-dialog/prompt-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class ChangeSaleNameDialogService {
    private readonly promptDialogService = inject(PromptDialogService);
    private readonly activeSaleService = inject(ActiveSaleService);
    private readonly alertDialogService = inject(AlertDialogService);
    private readonly configurationManagerService = inject(ConfigurationManagerService);

    public async openDialog(data?: { saleName: string }): Promise<{ saleName?: string }> {
        const canDeleteSale = this.configurationManagerService.isUserPermitted('cashregister.delete_sale');

        const saleName: string | undefined = await this.promptDialogService.openDialog({
            data: {
                title: 'SETTINGS.SETTINGS.SAVE_SALE',
                label: 'DIALOG.CHANGE_NAME_SALE.NAME_SALE',
                value: data?.saleName || '',
                maxLength: 30,
                clearable: true,
                disableClose: true,
                ...(canDeleteSale && {
                    actions: [{ icon: 'delete', callback: () => this.deleteSale() }]
                })
            }
        });

        return { saleName };
    }

    /** Returns false when the deletion failed, so the dialog stays open */
    private async deleteSale(): Promise<boolean> {
        try {
            await this.activeSaleService.deleteSale(undefined);
            return true;
        } catch (error: any) {
            this.alertDialogService.openDialog({ data: { messageLabel: error } });
            return false;
        }
    }
}
